// ======================================================================
// File Name       : MultiLanguageEdit
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { Component } from 'react';
import { Button, Col, Form, Image } from 'react-bootstrap';
import { HYPHEN, VALIDATE_TYPE } from '../../constants';
import {
  DOCUMENT_TYPE_DOCX_PPTX,
  MULTI_DOCUMENT_ACCEPT_FILE,
  MULTI_DOCUMENT_ACCEPT_TYPE, PDF_ACCEPT_FILE,
  PDF_ACCEPT_TYPE,
  PROCESS_STATUS,
} from '../../constants/ContentConstant';
import NoImage from '../../images/no-image-icon.png';
import { changeMultiLanguageStatus } from '../../utils/ContentUtils';
import RenderField from '../../utils/ReduxFormUtils';

class MultiLanguageEdit extends Component {

  render() {
    const { languageInfo, toShow, dataUrl, multiLanguageInfo, handleFileUpload, onTranslateBtnClick, isReference } = this.props;
    const { documentName, documentSize, languageCode } = multiLanguageInfo;
    const { contentSecernId, contentName, byLanguageCode, documentType } = languageInfo;
    const isTranslateDocument = DOCUMENT_TYPE_DOCX_PPTX.indexOf(documentType) > -1;
    const language = byLanguageCode && byLanguageCode[languageCode];
    const multiLanguageName = (language && language.multiLanguageName) || '';
    const multiLanguagePdfName = (language && language.multiLanguagePdfName) || '';
    const registFileName = isTranslateDocument ? multiLanguageName : multiLanguagePdfName;
    const isProcessing = language && parseInt(language.processStatus, 10) === PROCESS_STATUS.PROCESSING;
    const languageData = (
      <Form className='form-horizontal'>
        <Form.Group className="form-info">
          <Col sm={3} className="form-label">
            コンテンツ識別ID
          </Col>
          <Col sm={9} className="form-label">
            {contentSecernId}
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={3} className="form-label">
            コンテンツ名
          </Col>
          <Col sm={9} className="form-label" >
            {contentName}
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={3} className="form-label">
            言語
          </Col>
          <Col sm={2} className="form-label" >
            英語
          </Col>
        </Form.Group>

        <Form.Group className="form-info">
          <Col sm={3} className="form-label">
            翻訳ファイル名
          </Col>
          {registFileName && (
            <Col sm={9} className="form-label">
              <span
                className="text-decoration-underline text-outline-none bold text-primary"
                role="button"
                tabIndex={0}
                onClick={() => this.props.downloadDocument(registFileName, languageCode)}
              >
                {registFileName}
                <i
                  role="button"
                  className="bi bi-download text-primary padding-left-5"
                />
              </span>
            </Col>
          )}
          {!language && (
            <Col sm={9} className="form-label">
              {HYPHEN}
            </Col>
          )}
        </Form.Group>
        {!isReference && (
          <Form.Group className="form-info">
            <Col sm={12} className="padding-top-10 padding-left-right-clear displayBlock">
              <Col as={Form.Label} sm={3} className="language-upload-file-label">
                翻訳ファイルの新規登録・編集
              </Col>
              <Col as={Form.Label} sm={9} className="padding-left-right-clear float-end">
                <Col sm={12}>
                  翻訳ファイルを新規登録・編集する場合は、ファイルをアップロードしてください。
                </Col>
                <Col sm={12}>
                  <Col sm={12} className="language-upload-file-legend margin-top-10">
                    <Col as={Form.Label} sm={2}>
                      ファイル選択
                    </Col>
                    <Col sm={10}>
                      <RenderField
                        type="batchimport"
                        name="uploadFile"
                        label="ファイル選択"
                        validates={[VALIDATE_TYPE.REQUIRED, VALIDATE_TYPE.DOCUMENT_SIZE, VALIDATE_TYPE.ACCEPT_FILE]}
                        value={documentSize}
                        fileName={documentName}
                        fileSize={documentSize}
                        fieldInput={8}
                        fieldButton={4}
                        accept={isTranslateDocument ? MULTI_DOCUMENT_ACCEPT_TYPE : PDF_ACCEPT_TYPE}
                        acceptCheck={isTranslateDocument ? MULTI_DOCUMENT_ACCEPT_FILE : PDF_ACCEPT_FILE}
                      />
                    </Col>
                    <Col as={Form.Label} sm={12}>
                      ※利用可能なファイルの種類は、拡張子が {isTranslateDocument ? '「pptx」「docx」' : '「pdf」'}のファイルのみとなります。
                    </Col>
                    <Col as={Form.Label} sm={12}>
                      ※アップロードするファイルサイズの上限は200MBまでとなります。
                    </Col>
                    <Col as={Form.Label} sm={12}>
                      ※ファイル名は自動で変更されます。
                    </Col>
                    <Col as={Form.Label} sm={12}>
                      ※ オリジナルファイルと異なる拡張子はアップロードできません。
                    </Col>
                    <Col sm={10} className="text-center">
                      <Button
                        variant="primary"
                        className="btn-96 margin-bottom-20"
                        disabled={isProcessing}
                        onClick={handleFileUpload}
                      >
                        アップロード
                      </Button>
                    </Col>
                  </Col>
                </Col>
              </Col>
            </Col>
          </Form.Group>
        )}
        {isTranslateDocument && (
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              配信ファイル名
            </Col>
            {multiLanguagePdfName && (
              <Col sm={9} className="form-label">
                <span
                  role="button"
                  tabIndex={0}
                  className="text-decoration-underline text-outline-none bold text-primary"
                  onClick={() => this.props.downloadDocument(multiLanguagePdfName, languageCode)}
                >
                  {multiLanguagePdfName}
                  <i
                    role="button"
                    className="bi bi-download text-primary padding-left-5"
                  />
                </span>
              </Col>
            )}
            {!language && (
              <Col sm={9} className="form-label">
                {HYPHEN}
              </Col>
            )}
          </Form.Group>
        )}
        <Form.Group className="form-info">
          <Col sm={3} className="form-label">
            ステータス
          </Col>
          <Col sm={9} className="form-label">
            {language ? changeMultiLanguageStatus(language.processStatus) : HYPHEN}
          </Col>
        </Form.Group>
        <Form.Group className="form-info label-middle" >
          <Col sm={3} className="form-label">
            サムネイル
          </Col>
          {language && (
            <Col sm={9} className="form-label">
              {!toShow && dataUrl === '' &&
                <i
                  role="button"
                  className="bi bi-arrow-clockwise refresh-animate"
                />
              }
              {toShow && dataUrl !== NoImage &&
                <Image className="thumbnail" alt="NoImage" src={dataUrl} />
              }
              {toShow && dataUrl === NoImage &&
                <Image className="thumbnail" alt="NoImage" src={NoImage} />
              }
            </Col>
          )}
          {!language && (
            <Col sm={9} className="form-label">
              {HYPHEN}
            </Col>
          )}
        </Form.Group>
      </Form>
    );
    return (
      <Col sm={12} id="multiLanguageEdit">
        {languageData}
      </Col>
    );
  }
}

export default MultiLanguageEdit;
